const state = {
}

const getters = {
}

const mutations = {
}

const actions = {
  searchChat ({ state, commit, rootState }, params) {
    return rootState.axios.get('/magicbuy/tb-dgorder/tworld/search-chat', {
      params,
      baseURL: 'https://apisp.jyb.com.tw',
    })
  },
  sendChat ({ state, commit, rootState }, params) {
    return rootState.axios.post('/magicbuy/tb-dgorder/tworld/send-chat', params, {
      baseURL: 'https://apisp.jyb.com.tw',
    })
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
